module.exports = __webpack_public_path__ + "img/bg-accident-item-7.02966193.png";